import appStore from 'client/AppStore';
import {pick} from 'lodash';
import {getQueryStringForParams} from 'client/history';

export const searchCriteria = ['s', 'standards', 'tags'];

export const phrasesRegex = /(\w|\s)*\w(?=")/g;

export const phrasesAndTrailingSpacesRegex = /\s?"(\w|\s)*\w(?=").\s?/g;

export function parseSearchString(str: string): {
  isSearchingForKeywords: boolean;
  isSearchingForPhrases: boolean;
  keywords: string;
  phrases: Array<string>;
} {
  const keywords = parseKeywordsFromSearchString(str);
  const phrases = parsePhrasesFromSearchString(str);
  const isSearchingForKeywords = Boolean(keywords);
  const isSearchingForPhrases = phrases.length > 0;

  return {
    isSearchingForKeywords,
    isSearchingForPhrases,
    keywords,
    phrases
  };
}

export function parseKeywordsFromSearchString(str: string): string {
  return str
    .replace(phrasesAndTrailingSpacesRegex, '')
    .split(' ')
    .filter((keyword) => keyword)
    .join(','); // Remove empty strings
}

export function parsePhrasesFromSearchString(str: string): Array<string> {
  return phrasesRegex.test(str) ? str.match(phrasesRegex) ?? [] : [];
}

function getLocationQuery(): Record<string, string> {
  const location = appStore.routerProps.location as
    | {query?: Record<string, string>}
    | undefined;
  return location?.query ?? {};
}

export function isSearchingByKey(key: string): boolean {
  return searchCriteria.includes(key) && Boolean(getLocationQuery()[key]);
}

export function isSearchMode(): boolean {
  const query = getSearchParams();
  return Object.keys(query).some(isSearchingByKey);
}

export function getSearchParams(): Record<string, string> {
  return pick(getLocationQuery(), searchCriteria);
}

export function getIndexedSearchParams(): Record<string, Array<string>> {
  const query = getSearchParams();
  return searchCriteria.reduce<Record<string, Array<string>>>((acc, curr) => {
    acc[curr] = query[curr] ? query[curr].split(',') : [];
    return acc;
  }, {});
}

export function addSearchParamsToLink(link: string): string {
  const queryString = getQueryStringForParams(...searchCriteria);
  return `${link}${queryString ? '?' + queryString : ''}`;
}
